import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { IOrganizationWithMetadata } from '../interfaces/organization';

const name = 'organizationMetadata';

export const fetchOrganizationMetadata = createAsyncThunk(
  `${name}/fetch`,
  async (organizationId: string, { dispatch }) => {
    try {
      const { data } = await axios.get<IOrganizationWithMetadata>(`/api/v3.3/organizations/${organizationId}`);
      return data;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  organizationMetadata: IOrganizationWithMetadata | null;
};

const initialState: State = {
  organizationMetadata: null,
  isFetching: false,
  error: null
};

const organizationMetadata = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchOrganizationMetadata.pending, isFetching)
      .addCase(fetchOrganizationMetadata.fulfilled, (state, action) => {
        state.organizationMetadata = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchOrganizationMetadata.rejected, error);
  }
});

export const { reducer: organizationMetadataReducer } = organizationMetadata;
